import * as React from 'react';
import { css } from '@emotion/core';

import Button from '~/theseus/components/Button';

import FormPicker from './Picker';
import { Form } from '~/api/models/leadads/form';

interface Props {
  onToggleModes: () => void;
  onChange: (formId: string) => void;
  forms: Form[];
}

const FormSelector: React.FC<Props> = (props) => {
  const {
    onToggleModes,
    onChange,
    forms,
  } = props;

  return (
    <div>
      <Button
        variant="primary"
        onClick={onToggleModes}
        size="md"
        css={css`margin-bottom: 20px;`}
      >
        Create new form
      </Button>
      <FormPicker
        onSelect={onChange}
        forms={forms}
      />
    </div>
  );
};

export default FormSelector;
